var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngola(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3546 9.54431L11.3719 10.2826L10.9842 11.4783L12.0007 10.7388L13.0181 11.4771L12.629 10.2817L13.6454 9.54234L12.3884 9.54309L11.9992 8.34783L11.6115 9.54352L10.3546 9.54431Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.80386C14.0544 6.25791 13.0205 6.00023 12 6.00202V7.56689C12.7543 7.56553 13.5184 7.75584 14.2174 8.15944C16.3351 9.38212 17.0633 12.0998 15.8406 14.2175C14.6179 16.3352 11.9003 17.0634 9.78257 15.8407C9.1656 15.4845 8.66756 15.0008 8.30043 14.4427L6.99374 15.3054C7.49048 16.0605 8.16529 16.7143 8.99999 17.1961C11.8652 18.8504 15.5419 17.8652 17.1961 15C18.8503 12.1348 17.8652 8.45808 15 6.80386Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54014 10.9565C8.1253 11.7149 8.40383 12.666 9.16217 13.0809L14.2457 15.8587C13.9 16.4906 14.0836 17.2598 14.7155 17.6055L16.0888 18.3567C16.7207 18.7024 17.5134 18.4703 17.8591 17.8383L18.6103 16.4652L8.54014 10.9565Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngola);
export default __webpack_public_path__ + "static/media/angola.ab722a7186c758c83bfa7d50425522c0.svg";
export { ForwardRef as ReactComponent };